import { observer } from "mobx-react";
import React from "react";
import { useStore } from "../../../contexts/store-provider";
import { IOption } from "../../../models/ICommon";
import { ISaleRecordList } from "../../../models/response/ISMRResponse";
import AddEditSaleRecordForm from "../forms/add-edit-sale-record-form";
import { getHeadquarterIdFromLocalStorage } from "../../../helpers/localstorage-helper";
import { saleRecordPaymentType } from "../../../constants/enums/sale-record-payment-type-enum";
import _ from "lodash";

interface IProps {
  smrId: number;
  customerId: number;
  storeId: number;
  saleRecordItem: ISaleRecordList | undefined;
  getAllStaffOptions: IOption[];
  isDisabled: boolean;
  viewOnly: boolean;
  shouldPreventScroll?: React.MutableRefObject<boolean>;
}

const AddEditSaleRecord = (props: IProps) => {
  const {storeId, customerId, smrId, saleRecordItem, getAllStaffOptions, isDisabled, viewOnly} = props;
  const { smrStore, customerManagementStore } = useStore();
  const { AddSaleRecordService, UpdateSaleRecordService, 
    getInitailAddSaleRecordDetails, registerSale, 
    selectedSaleRecrodForCreatingNewSale} = smrStore;

  const onSubmitForm = (values: any, id: number, smrId: number, showAccountingPopup: boolean = false) => {
    if(registerSale || selectedSaleRecrodForCreatingNewSale > -1)
    {
        let tempValues:any = _.omit(values, 'TaxTotal');
        tempValues.CustomerId = customerId;
        tempValues.StoreId = storeId;
        if(registerSale){
          tempValues.AppointmentId = null;
          tempValues.HeadquaterId = getHeadquarterIdFromLocalStorage();
        }
        if(selectedSaleRecrodForCreatingNewSale > -1)
        {
            tempValues.SMRId = smrId;
            tempValues.SaleId = selectedSaleRecrodForCreatingNewSale;
            tempValues.SaleRecordPaymentStatus = false;
        }
        AddSaleRecordService(tempValues, saleRecordPaymentType.Credit);
    }
    else{
      UpdateSaleRecordService(values, id, showAccountingPopup, smrId, customerId, storeId)
    }
  };


  return (
    <React.Fragment>
      <AddEditSaleRecordForm
        smrId={smrId}
        initialValues={!registerSale ? saleRecordItem : {...getInitailAddSaleRecordDetails,
            StaffId: getAllStaffOptions?.length > 0 ? getAllStaffOptions[0]?.id : -1
        }}
        getAllStaffOptions={getAllStaffOptions}
        submitHandler={onSubmitForm}
        customerId={customerId}
        storeId={storeId}
        isDisabled={isDisabled}
        viewOnly={viewOnly}
      />
    </React.Fragment>
  );
};

export default observer(AddEditSaleRecord);
